import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Ruta } from "../../../Ruta"
import { SkolServiciosSection } from "../SkolServiciosSection"
import "./landing.scss"

export const LandingSection = () => {
  const rutaTitle = "Servicios"
  const subRuta = "Soporte"
  const title = ["Servicios", ""]
  const classTitle = "servicios"
  return (
    <>
      <Ruta
        rutaTitle={rutaTitle}
        subRuta={subRuta}
        title={title}
        classTitle={classTitle}
      />
      <div
        className="servicios-portada-container"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <StaticImage
          src="../../../../images/servicios/landing/portada-servicios.png"
          alt="portada"
          placeholder="blurred"
          layout="fullWidth"
        />
      </div>
      <SkolServiciosSection />
    </>
  )
}
